import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { GlobalProvider } from '../../providers/global/global';
import { ThankYouPage } from '..//thank-you/thank-you';
import { HttpClient, HttpParams } from '@angular/common/http';
import { TimesheetlistPage } from '../../pages/timesheetlist/timesheetlist';
import { PopoverController } from 'ionic-angular';
import { PopoverPage } from '../popover/popover';
import { RejectPage } from '../../pages/reject/reject';
/**
 * Generated class for the ConfirmPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-confirm',
  templateUrl: 'confirm.html',
})
export class ConfirmPage {

  res1: any;
  // dt1: any;
  // dt2: any;
  dt1table3: any;
  dt2table3: any;
  tab2id: string;

  grid1Total: string;
  grid2Total: number = 0;
  overtimeTotal: string;
  splittedValues: Array<string>;
  overtimesplittedValues: Array<string>;
  hourSum: number = 0;
  minuteSum: number = 0;

  overtimehourSum: number = 0;
  overtimeminuteSum: number = 0;

  dayValues: Array<number> = [];

  res_approve: any;
  nrowsGrid1: number;
  nrowsGrid2: number;

  shownGroup = null;
  nrowsExpenses: number;


  constructor(public http: HttpClient, public global: GlobalProvider, public navCtrl: NavController,
    public navParams: NavParams, public loadingCtrl: LoadingController, public popoverCtrl: PopoverController
    , private alertCtrl: AlertController) {


    //this.tab2id = this.navParams.get('TAB2ID');
    // this.dt1 = this.navParams.get('dt1');
    // this.dt2 = this.navParams.get('dt2');
    // debugger;
    // console.log('expenses:',this.global.expensesVisibility);
    // console.log(this.global.dt_expenses_total_confirm);

    if (this.global.grid1Visibility) {

      //debugger;
      this.dt1table3 = JSON.parse(this.global.dt_grid1[2]);
      //nRows represent the number of rows to be drawn in Grid1, whether there will be overtime,.. or not.
      this.nrowsGrid1 = this.dt1table3.length;
      //console.log('nRowsGrid1: ' + this.nrowsGrid1);
    }



    if (this.global.grid2Visibility) {
      this.dt2table3 = JSON.parse(this.global.dt_grid2[2]);

      //nRows represent the number of rows to be drawn in Grid2, whether there will be overtime,.. or not.
      this.nrowsGrid2 = this.dt2table3.length;
      //console.log('nRowsGrid2: ' + this.nrowsGrid2);
    }

    if (this.global.expensesVisibility) {
      this.nrowsExpenses = this.global.dt_expenses_total_confirm.length;
    }
    //this.global.rate[this.global.timesheetIndex] = this.global.rate[this.global.timesheetIndex];

  }

  presentPopover(myEvent) {
    let popover = this.popoverCtrl.create(PopoverPage);
    popover.present({
      ev: myEvent
    });
  }
  toggleGroup(group) {
    if (this.isGroupShown(group)) {
      this.shownGroup = null;
    } else {
      this.shownGroup = group;
    }
  };

  isGroupShown(group) {
    return this.shownGroup === group;
  };
  httpRequest_approve() {
    //debugger
    //added to prevent consultants from chi approving timesheets
    if (this.global.AllowApproval === '0' && this.global.contacttype == '0') {
      let alert = this.alertCtrl.create({
        message: 'You are not authorised to approve this timesheet.',
        buttons: [
          {
            text: 'OK',
            handler: () => {
              //back to timesheetlist
              this.navCtrl.push(TimesheetlistPage);

            }
          }
        ]
      });
      alert.present();
    }
    else {

      this.global.createLoader();
      this.global.loading.present().then((result) => {


        var p: any = {};
        p.timesheetid = this.global.timesheetid;
        p.contacttype = this.global.contacttype;
        p.zeroreason = '';

        if (this.global.contacttype == '1') {

          p.caption = 'SUBMIT TIMESHEET';

        }
        else if (this.global.contacttype == '0') {

          p.caption = 'Approve Now';

        }

        const params = new HttpParams().set('j', JSON.stringify(p));

        this.http.post('timesheets/timesheet_approve/', params).subscribe(

          (data) => {
            //debugger;

            this.global.loading.dismiss();

            this.res_approve = data;
            //console.log(this.res_approve);
            if (this.res_approve.result == true) {

              var sp_response = JSON.parse(this.res_approve.dt)[0];
              if (sp_response['Success'] == false) {
                this.presentOKAlert(sp_response['Result']);
              }
              else {
                this.navCtrl.push(ThankYouPage);
              }


            }
          },
          error => {
            alert(error);
          }
        );

      }).catch((err) => {

      });
    }

  }

  async checkButton2Caption() {

    var caption = this.global.button2caption;
    var validator = this.global.button2validator;
    if (caption.trim().toLowerCase() == "Reject Now".trim().toLowerCase()) {
      //go to reject page
      this.navCtrl.push(RejectPage);
      return;
    }
    else if (validator.trim() != "") {
      //show pop
      var res = await this.presentYESNOAlert(validator);
      if (res) {
        this.callButton2Sp();
      }
    }
    else {

      this.callButton2Sp();

    }
  }
  callButton2Sp() {

    this.global.createLoader();
    this.global.loading.present().then((result) => {


      var p: any = {};
      p.timesheetid = this.global.timesheetid;
      p.button2caption = this.global.button2caption;
      
      const params = new HttpParams().set('j', JSON.stringify(p));

      this.http.post('timesheets/timesheet_button2/', params).subscribe(

        (data) => {
          //debugger;

          this.global.loading.dismiss();

          this.res_approve = data;
          //console.log(this.res_approve);
          if (this.res_approve.result == true) {

            //back to timesheetlist
            this.navCtrl.push(TimesheetlistPage);

          }
        },
        error => {
          alert(error);
        }
      );

    }).catch((err) => {

    });
  }
  async presentYESNOAlert(message) {

    return new Promise((resolve, reject) => {
      let alert = this.alertCtrl.create({
        message: message,
        buttons: [
          {
            text: 'Yes',
            handler: () => {
              //callback();
              resolve(1);
            }
          },
          {
            text: 'No',
            role: 'cancel',
            handler: () => {
              resolve(0);
            }
          }
        ]
      });
      alert.present();
    })

  }

  async presentOKAlert(message) {

    return new Promise((resolve, reject) => {
      let alert = this.alertCtrl.create({
        message: message,
        buttons: [
          {
            text: 'OK',
            handler: () => {
              //callback();
              resolve(1);
            }
          }

        ]
      });
      alert.present();
    })

  }
  /////////client////////
  // httpRequest_rating_save(){


  //   var p:any={};

  //   p.contacttype = this.global.contacttype;
  //   p.timesheetid = this.global.timesheetid;
  //   p.rating = this.global.rate[this.global.timesheetIndex];

  //   const params = new HttpParams()
  //   .set('j',JSON.stringify(p))


  //   this.http.post('timesheets/timesheet_rating_save/',params).subscribe(

  //     (data) => {

  //       console.log('Rating saved');

  //     },
  //     error => {alert('error');}
  //   );
  // }

  goToThankyou() {

    this.httpRequest_approve();
  }

  backToTimesheets() {

    this.global.ndaysIndex = 1;
    this.navCtrl.push(TimesheetlistPage);
  }

  /////////client////////
  // onRateChange(){

  //   console.log(this.global.rate[this.global.timesheetIndex]);

  //   this.httpRequest_rating_save();
  // }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ConfirmPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/confirm/confirm.ts